export default __webpack_public_path__ + "static/media/PSO 09 - Operações - Aperam.4749e407.pdf";